import { Container,  Text, Stack,  Grid, Divider, Button } from '@mantine/core'
import { useStorageContext } from '@/contexts/StorageContext'
import { CarIcon } from '@/components/CarIcon/CarIcon'
import { MotorcycleIcon } from '@/components/MotorcycleIcon/MotorcycleIcon'
import { servicesPageStyles } from './ServicesPage.styles'

export function ServicesPage() {
  const storage = useStorageContext()
  const autoList = storage.autoList
const getImage = (img: string) => {
  if (img === "Car") {
    return <CarIcon size={100} color='#002f2f'/>
  }
  if (img === "Motorcycle") {
    return <MotorcycleIcon size={100} color='#002f2f'/>
  }
  return <img src={img} alt={img} color='#002f2f' />
}

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
    {autoList.filter((item) => item.view).map((item, index) => (
      <Stack key={index} style={servicesPageStyles.serviceCard}>
      <Grid  >
        <Grid.Col span={3}>
        {getImage(item.img)}
        
        </Grid.Col>
        <Grid.Col span={9}>

  
        <Text fw={700} ta="center" c="#002f2f" style={{ fontSize: '1.5rem' }} mb="md" mt="md"  mx="auto">{item.name}</Text>
        </Grid.Col>
        </Grid>

        <Divider />
        <Grid style={{width: '100%'}}>
          <Grid.Col span={5}>
            <Text ta="center" c="#002f2f">Стоимость:</Text>
          <Text ta="center" c="#002f2f" fw={900} style={{ fontSize: '1.5rem' }} >{item.startPrice} <Text span c="#002f2f" style={{ fontSize: '1rem' }}>руб.</Text></Text> 
          </Grid.Col>
          <Grid.Col span={7}>
            <Button variant="filled" size='lg' color="#002f2f" mt="md" fullWidth onClick={() => {window.location.href = '/booking'}}>Записаться</Button>
          </Grid.Col>
        </Grid>
</Stack>

    ))}
      </Stack>
    </Container>
  )
}